import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  DownArrow,
  ExpandedRowContainer,
  ExpandedRowDetails,
  ExpandedRowText,
  UpArrow
} from './style';

export const FileHistoryRowData = ({
  rowData,
  handleRowDetail,
  showRowDetail,
  selectedFileName
}) => {
  const { t } = useTranslation();

  return (
    <ExpandedRowContainer>
      <ExpandedRowDetails
        justify={
          rowData.fileStatus === 'SUCCESS' ? 'flex-start' : 'space-between'
        }
      >
        <ExpandedRowText fileStatus={rowData.fileStatus}>
          {rowData.fileStatus === 'SUCCESS'
            ? t('success_detail_text_lead', {
                created_count: rowData.createdCount
              })
            : t('error_detail_text_lead', {
                created_count: rowData.createdCount,
                error_count: rowData.totalCount - rowData.createdCount
              })}
        </ExpandedRowText>
        {rowData.fileStatus !== 'SUCCESS' && (
          <div onClick={() => handleRowDetail(rowData.fileName)}>
            <ExpandedRowText fileStatus={rowData.fileStatus}>
              {showRowDetail && selectedFileName === rowData.fileName ? (
                <>
                  {t('hide_details')}{' '}
                  <UpArrow type="fileHistory" fileStatus={rowData.fileStatus} />{' '}
                </>
              ) : (
                <>
                  {' '}
                  {t('show_details')}
                  <DownArrow
                    type="fileHistory"
                    fileStatus={rowData.fileStatus}
                  />{' '}
                </>
              )}
            </ExpandedRowText>
          </div>
        )}
      </ExpandedRowDetails>
    </ExpandedRowContainer>
  );
};

FileHistoryRowData.propTypes = {
  rowData: PropTypes.object,
  handleRowDetail: PropTypes.func,
  showRowDetail: PropTypes.bool,
  selectedFileName: PropTypes.string
};
